module.exports = __webpack_public_path__ + "media/customer_tickets/whatsapp-8d393a9a.svg";